import React from "react";
import {
  Building2,
  UserRound,
  Truck,
  Phone,
  MapPin,
} from "lucide-react";
// import "./QuickAssist.css";

const contacts = [
  {
    title: "For inquiries about companies:",
    icon: Building2,
    people: [
      { name: "Iyad Ghulam", phone: "0504365448" },
      { name: "Abdullah Almazroa", phone: "0567288028" },
    ],
  },
  {
    title: "For inquiries about investors:",
    icon: UserRound,
    people: [
      { name: "Saad Iqbal", phone: "0532031462" },
    ],
  },
  {
    title: "For inquiries about logistics:",
    icon: Truck,
    people: [
      { name: "Farah Ben Khadra", phone: "0550500951" },
      { name: "Ammar Alshbeki", phone: "0560981666" },
    ],
  },
];

const venueUrl =
  "https://maps.app.goo.gl/32xyDbn9R7P7DZmR9?g_st=iw";

const QuickAssist = () => {
  return (
    <div className="quick-assist-page">
      <div className="container-fluid px-3 px-md-5">
        <div className="quick-assist-content">

          <div className="quick-assist-sections">
            {contacts.map((section, index) => {
              const Icon = section.icon;

              return (
                <div className="quick-assist-card" key={index}>
                  <div className="quick-assist-card-icon">
                    <Icon size={28} strokeWidth={1.8} />
                  </div>

                  <div className="quick-assist-card-content">
                    <h3>{section.title}</h3>

                    <div className="quick-assist-contacts">
                      {section.people.map((person, personIndex) => (
                        <div
                          className={`quick-assist-contact ${
                            personIndex !== section.people.length - 1
                              ? "contact-border"
                              : ""
                          }`}
                          key={person.phone}
                        >
                          <span className="quick-assist-name">
                            {person.name}
                          </span>

                          <a
                            href={`tel:${person.phone}`}
                            className="quick-assist-phone"
                          >
                            <Phone size={17} strokeWidth={2} />
                            <span>{person.phone}</span>
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}

            <div className="quick-assist-card venue-card">
              <div className="quick-assist-card-icon">
                <MapPin size={28} strokeWidth={1.8} />
              </div>

              <div className="quick-assist-card-content">
                <h3>Venue location:</h3>

                <p className="venue-name">
                  Sofitel – Riyadh Hotel & Convention Centre
                </p>

                <a
                  href={venueUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="maps-button"
                >
                  <MapPin size={18} strokeWidth={2} />
                  <span>Open in Google Maps</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickAssist;